import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["role", "children", "onClick"];
import { createContext, useContext } from 'react';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { ControlProvider } from '../Link/ControlContext';
import { jsx as _jsx } from "react/jsx-runtime";
const BackButtonContext = /*#__PURE__*/createContext({
  backButton: false
});
export const useBackButtonContext = () => {
  return useContext(BackButtonContext);
};
const CONTEXT_VALUE = {
  backButton: true
};
export const BackButton = _ref => {
  let {
      role = 'navigation',
      children,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ControlProvider, {
    isControl: true,
    children: /*#__PURE__*/_jsx(BackButtonContext.Provider, {
      value: CONTEXT_VALUE,
      children: /*#__PURE__*/_jsx(Breadcrumbs, Object.assign({}, rest, {
        flush: true,
        role: role,
        backButtonOnClick: onClick,
        [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'BackButton',
        children: children
      }))
    })
  });
};
BackButton.displayName = 'BackButton';